module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": _vm.formData.id == 0 ? 'Nova Conta WhatsApp' : 'Editar Conta WhatsApp',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Nome da Conta")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "Nome identificador para esta conta de WhatsApp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "500",
      "show-word-limit": "",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.nome),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nome", $$v)
      },
      expression: "formData.nome"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Phone Number ID")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    ID do número de telefone na Meta."), _c('br'), _vm._v("\n                    Encontre em: Meta Business Suite > WhatsApp > Configurações da API\n                  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "255",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.phone_number_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone_number_id", $$v)
      },
      expression: "formData.phone_number_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Business Account ID")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top",
      "content": "ID da conta WhatsApp Business na Meta"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": "255",
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.business_account_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "business_account_id", $$v)
      },
      expression: "formData.business_account_id"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('el-form-item', [_c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('label', [_vm._v("Access Token")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "350px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                    Token de acesso permanente da Meta."), _c('br'), _vm._v("\n                    Gere em: Meta Business Suite > WhatsApp > Configurações da API > Token de acesso permanente\n                  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": _vm.showAccessToken ? 'text' : 'password',
      "autocomplete": "false"
    },
    model: {
      value: (_vm.formData.access_token),
      callback: function($$v) {
        _vm.$set(_vm.formData, "access_token", $$v)
      },
      expression: "formData.access_token"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "title": _vm.showAccessToken ? 'Ocultar token' : 'Mostrar token'
    },
    on: {
      "click": function($event) {
        _vm.showAccessToken = !_vm.showAccessToken
      }
    },
    slot: "append"
  }, [_c('i', {
    class: _vm.showAccessToken ? 'fa fa-eye-slash' : 'fa fa-eye'
  })])], 1)], 1)], 1)])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cbc3cb7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/conta-whatsapp/editar.vue
// module id = 1450
// module chunks = 45